import { useCallback, useState } from 'react'

import { useQueryPODisclaimerLabels } from '@webapp/modules/purchasing/features/list-po-disclaimer-labels/models'

const PAGE_SIZE = 10

export const usePODisclaimerLabelListPresenter = () => {
  const [page, setPage] = useState(1)

  const { labels, pagination, isLoading, isFetching } =
    useQueryPODisclaimerLabels({
      page,
      pageSize: PAGE_SIZE,
    })

  const onPrevPage = useCallback(() => {
    setPage((currentPage) => Math.max(1, currentPage - 1))
  }, [])

  const onNextPage = useCallback(() => {
    setPage((currentPage) =>
      pagination.numPages > 0
        ? Math.min(pagination.numPages, currentPage + 1)
        : currentPage
    )
  }, [pagination.numPages])

  return {
    data: {
      labels,
      numPages: pagination.numPages,
    },
    states: {
      page,
      isLoading,
      isFetching,
    },
    methods: {
      onPrevPage,
      onNextPage,
    },
  }
}
